/** Named box-shadow values to indicate different depths of elements */
export var elevation = {
    content: "\n    0 3px 4px 0 rgba(0, 0, 0, 0.14),\n    0 3px 3px -2px rgba(0, 0, 0, 0.12),\n    0 1px 8px 0 rgba(0, 0, 0, 0.2)\n  ",
    contentNavigation: "\n    0 6px 10px 0 rgba(0, 0, 0, 0.14),\n    0 3px 5px -1px rgba(0, 0, 0, 0.2),\n    0 1px 18px 0 rgba(0, 0, 0, 0.12)\n  ",
    notification: "\n    0 9px 12px 1px rgba(0, 0, 0, 0.14),\n    0 5px 6px -3px rgba(0, 0, 0, 0.2),\n    0 3px 16px 2px rgba(0, 0, 0, 0.12)\n  ",
    modal: "\n    0 7px 8px -4px rgba(0, 0, 0, 0.2),\n    0 5px 22px 4px rgba(0, 0, 0, 0.12),\n    0 12px 17px 2px rgba(0, 0, 0, 0.14)\n  "
};
//# sourceMappingURL=elevation.js.map